import React, { useEffect, useState, useMemo, useCallback } from "react";
import * as XLSX from "xlsx";
import {
  Button,
  Col,
  Input,
  Row,
  Select,
  Space,
  Table,
  DatePicker,
  Typography,
  Modal,
  Form,
  Menu,
  Dropdown,
  Checkbox,
  message,
  Radio,
} from "antd";
import dayjs from "dayjs";
import moment from "moment";
import { JournalCentralService } from "../Services/JournalCentralService";
import { TraitementService } from "../Services/TraitementService";
import { ExpandOutlined, ReadOutlined } from "@ant-design/icons";
import "../Pages/CSS/Traitement.css";
const { confirm } = Modal;
const { Title } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const JournalCentral = () => {
  const [form] = Form.useForm();
  const journalCentralService = new JournalCentralService();
  const traitementsoinsService = new TraitementService();
  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };
  const [pageSize, setPageSize] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [tableData1, setTableData1] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);

  const [isValidating, setIsValidating] = useState(false);
  const [dateDeb, setDateDeb] = useState(null);
  const [dateFin, setDateFin] = useState(null);
  const [journalData, setJournalData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectJournal, setSelectJournal] = useState("All");
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [years, setYears] = useState([]);
  const [paramData, setParamData] = useState([]);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [filteredTableData1, setFilteredTableData1] = useState([]);
  const [isDefinitiveReport, setIsDefinitiveReport] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchText1, setSearchText1] = useState("");
  const [isAdvancedSearchVisible, setIsAdvancedSearchVisible] = useState(false);
  const [advancedSearch, setAdvancedSearch] = useState({
    numpiece: "",
    datetrait: [],
    codej: "",
    numcheque: "",
    numfactipm: "",
    numfactfrs: "",
    codebenef: "",
    comptegen: "",
    comptetiers: "",
    datedeb: "",
    datefin: "",
  });

  const [advancedDateDeb, setAdvancedDateDeb] = useState(() =>
    new Date().toISOString().split("T")[0]
  );

  const [advancedDateFin, setAdvancedDateFin] = useState(() =>
    new Date(new Date().getFullYear(), 11, 31).toISOString().split("T")[0]
  );


  const fetchDataInit = async () => {
    try {
      const getParam = await traitementsoinsService.getParamComptable();
      setParamData(getParam);

      // Extraire l'année de datedeb et l'utiliser pour initialiser selectedYear
      const yearFromParamData = dayjs(getParam.datedeb).format("YYYY");
      setSelectedYear(yearFromParamData);

      const monthFromParamData = dayjs(getParam.datedeb).format("MM");
      setSelectedMonth(monthFromParamData);
    } catch (error) {
      console.error("Erreur lors de la récupération des paramètres comptables :", error);
    }
  };


  useEffect(() => {

    fetchDataInit();
    return () => { };
  }, []);

  useEffect(() => {
    if (selectedYear) {
      const year = parseInt(selectedYear, 10);
      setAdvancedDateDeb(new Date(year, 0, 1).toISOString().split("T")[0]);
      setAdvancedDateFin(new Date(year, 11, 31).toISOString().split("T")[0]);
    }
  }, [selectedYear]);


  const fetchData = async () => {
    setIsLoading(true);
    try {
      // const getParam = await traitementsoinsService.getParamComptable();
      // setParamData(getParam);
      // Extraire le mois de datedeb et mettre à jour selectedMonth
      //const monthFromParamData = dayjs(getParam.datedeb).format("MM");
      //setSelectedMonth(monthFromParamData);
      if (selectedMonth !== null) {
        let data;
        if (selectedMonth === "14" && dateDeb && dateFin) {
          data = await journalCentralService.getListJournalCentral14(
            selectedYear,
            selectedMonth,
            dateDeb,
            dateFin
          );
        } else {
          data = await journalCentralService.getListJournalCentral(
            selectedYear,
            //monthFromParamData
            selectedMonth
          );
        }

        let filteredData = data;
        if (selectJournal !== "All") {
          filteredData = data.filter((d) => d.codej === selectJournal);
        }
        setTableData(filteredData);

        const yearsData = await journalCentralService.getComptaExercices();
        setYears(yearsData);

        const listData = await journalCentralService.getList();
        setJournalData(listData);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedYear) {
      fetchData();
    }
  }, [selectedYear, selectedMonth, selectJournal]);

  useEffect(() => {
    if (selectedMonth === "14" && dateDeb && dateFin) {
      fetchData();
    }
  }, [dateDeb, dateFin]);

  const onchangePrestation = useCallback((value) => {
    setSelectJournal(value);
  }, []);

  const handleClotureMensuelle = async () => {
    confirm({
      title: "Confirmation",
      content: (
        <>
          Veuillez confirmer la clôture mensuelle du mois de
          <strong> {formatDateToMonthYear(paramData.datedeb)} </strong>
        </>
      ),
      okText: "Confirmer",
      cancelText: "Annuler",
      onOk: async () => {
        try {
          // Appeler l'API closeMensuel en premier
          await traitementsoinsService.closeMensuel();

          // Construire le payload
          const payload = {
            numparam: "param3",
            perim: "IPM",
          };

          // Appeler l'API closeOpenMensuel avec le payload
          await traitementsoinsService.closeOpenMensuel(payload);

          // Appeler param3() et attendre que paramData soit mis à jour
          const updatedParam = await traitementsoinsService.getParamComptable();
          setParamData(updatedParam);

          // Utiliser le nouveau paramData après la mise à jour
          const newDateDeb = formatDateToMonthYear(updatedParam.datedeb);
          fetchData();
          fetchDataInit();
          // Afficher un message de succès avec le mois mis à jour
          message.success(`Clôture mensuelle confirmée. Nouveau mois : ${newDateDeb}`);
        } catch (error) {
          console.error("Erreur lors de la clôture mensuelle :", error);
          message.error("Erreur lors de la clôture mensuelle");
        }
      },
      onCancel() {
        message.info("Clôture mensuelle annulée");
      },
    });
  };

  const handleValidate = async () => {
    setIsValidating(true); // Désactiver le bouton Valider pendant l'exécution
    try {
      const payload = {
        close_def: isDefinitiveReport, // Utiliser l'état de la checkbox
        exercice: selectedYear, // Passer l'année sélectionnée
      };

      // Appeler l'API newExo
      const response = await traitementsoinsService.newExo(payload);

      // Gérer la réponse de l'API
      message.success("Validation réussie !");
      setIsModalOpen(false); // Fermer le modal si nécessaire
    } catch (error) {
      message.error("Erreur lors de la validation");
      console.error("Erreur lors de l'appel à l'API newExo :", error);
    } finally {
      setIsValidating(false); // Réactiver le bouton Valider
    }
  };

  const handleReculClotureMens = async () => {
    Modal.confirm({
      title: "Confirmation",
      content: "Êtes-vous sûr de vouloir confirmer le retour mensuel ?",
      okText: "Oui",
      cancelText: "Non",
      onOk: async () => {
        try {
          await traitementsoinsService.reculClôtureMensuel();
          fetchData();
          fetchDataInit();
          message.success("Retour mensuel confirmé");
        } catch (error) {
          console.error("Erreur lors du retour mensuel :", error);
          message.error("Erreur lors du retour mensuel");
        }
      },
    });
  };

  const handleYearChange = useCallback((value) => {
    setSelectedYear(value);
  }, []);

  const handleDateChange = useCallback((dates, dateStrings) => {
    if (dates && dates.length === 2) {
      setDateDeb(dates[0].toISOString().split("T")[0]);
      setDateFin(dates[1].toISOString().split("T")[0]);
    } else {
      setDateDeb(null);
      setDateFin(null);
    }
  }, []);

  const handleAdvancedSearchChange = useCallback((key, value) => {
    setAdvancedSearch((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  }, []);

  const fetchTableData = async () => {
    setIsLoadingModal(true)
    try {
      const data = await journalCentralService.getNouvExerc(selectedYear);
      setTableData1(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    } finally {
      setIsLoadingModal(false);
    }
  };

  const handleExercise = useCallback(() => {
    setIsModalOpen(true);
    fetchTableData(); // Récupère les données lorsque le modal est ouvert
  }, [selectedYear]);

  const gestionMenu = useMemo(
    () => (
      <Menu>
        <Menu.Item key="1" onClick={handleClotureMensuelle}>
          Clôture mensuelle
        </Menu.Item>
        <Menu.Item key="2" onClick={handleReculClotureMens}>
          Reculer Mois Compta
        </Menu.Item>
        <Menu.Item key="3" onClick={handleExercise}>
          Nouvel exercice
        </Menu.Item>
      </Menu>
    ),
    [handleClotureMensuelle, handleReculClotureMens, handleExercise]
  );

  const executeAdvancedSearch = async () => {
    const getRange = (value) => {
      if (!value) {
        return null; // Retourne null si rien n'est saisi
      }

      if (value.includes("-")) {
        const [min, max] = value.split("-").map((v) => v.trim()); // Pas de limitation de longueur ici
        return { min, max };
      }

      return { min: value, max: value }; // Retourne la même valeur pour min et max si une seule valeur est saisie
    };

    const sousCompteRange = getRange(advancedSearch.souscompte);


    const payload = {
      codej: advancedSearch.codej || null,
      comptegen: advancedSearch.comptegen || null,
      comptetiers: advancedSearch.comptetiers || null,
      datecompta: null,
      datedeb: advancedDateDeb || null,
      datefin: advancedDateFin || null,
      datepiece: null,
      libelle: null,
      matri: null,
      numcheque: advancedSearch.numcheque || null,
      numfactfrs: advancedSearch.numfactfrs || null,
      numfactipm: advancedSearch.numfactipm || null,
      numpiece: advancedSearch.numpiece || null,
      souscompte: sousCompteRange ? `${sousCompteRange.min}-${sousCompteRange.max}` : null,
    };

    try {
      console.log("Payload envoyé :", payload); // Log pour vérifier le contenu du payload
      const response = await journalCentralService.searchAdvanceJournalCentral(payload);
      setFilteredTableData(response);
      setIsAdvancedSearchVisible(false);
    } catch (error) {
      console.error("Erreur lors de la recherche avancée :", error);
      message.error("Erreur lors de la recherche avancée");
    }
  };


  const resetAdvancedSearch = () => {
    form.resetFields();
    setAdvancedSearch({
      numpiece: "",
      datetrait: [],
      codej: "",
      numcheque: "",
      numfactipm: "",
      numfactfrs: "",
      codebenef: "",
      comptegen: "",
      comptetiers: "",
      datedeb: "",
      datefin: "",
    });
    setFilteredTableData(tableData);
    setIsAdvancedSearchVisible(false);
  };

  const exportToExcel = (data, fileName = "export.xlsx") => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, fileName);
  };

  const prepareDataForExport = (data) => {
    return data.map((row) => ({
      CodeJ: row.codej,
      DateCompta: row.datecompta,
      MoisTrait: row.datetrait,
      NumPiece: row.numpiece,
      NumCheque: row.numcheque,
      NumFIPM: row.numfactipm,
      CompteGen: row.comptegen,
      CompteTiers: row.comptetiers,
      Matricule: row.matri,
      Libelle: row.libelle,
      Debit: row.debit,
      Credit: row.credit,
    }));
  };

  const columns = useMemo(
    () => [
      {
        title: "C.JL",
        dataIndex: "codej",
        key: "codej",
        align: "center",
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8, width: 200 }}>
            {/* Recherche personnalisée */}
            <Input
              placeholder="Rechercher..."
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys([e.target.value])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8 }}
            />

            {/* Boutons */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: "48%" }}
              >
                Reset
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: "48%" }}
              >
                Ok
              </Button>
            </div>
          </div>
        ),
        filters: [
          ...new Set(
            filteredTableData.map((item) => item?.codej).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
          )
        ].map((value) => ({
          text: value,
          value: value,
        })),
        onFilter: (value, record) => record.codej === value,
        sorter: (a, b) => a.codej - b.codej,
      },
      {
        title: "D. Compta",
        dataIndex: "datecompta",
        key: "datecompta",
        align: "center",
        // sorter: (a, b) => a.datecompta - b.datecompta,
        sorter: (a, b) => {
          const valueA = new Date(a.datecompta).getTime();
          const valueB = new Date(b.datecompta).getTime();
          return valueA - valueB;
        },
        render: (text) => (text ? moment(text).format("DD/MM/YYYY") : ""),
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8 }}>
            <DatePicker
              placeholder="Rechercher une date"
              value={selectedKeys[0] ? dayjs(selectedKeys[0]) : null}
              format="DD/MM/YYYY"
              disabledDate={(current) => current && current > dayjs().endOf('day')}
              onChange={(date) => {
                if (date) {
                  setSelectedKeys([date.format("YYYY-MM-DD")]);
                } else {
                  setSelectedKeys([]);
                }
              }}
              style={{ marginBottom: 8, width: "100%" }}
            />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: "48%" }}
              >
                Réinitialiser
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: "48%" }}
              >
                Rechercher
              </Button>
            </div>
          </div>
        ),
        onFilter: (value, record) => {
          const recordDate = record.datecompta ? moment(record.datecompta).format("YYYY-MM-DD") : "";
          return recordDate === value;
        },
      },
      {
        title: "Mois trait.",
        dataIndex: "datetrait",
        key: "datetrait",
        align: "center",
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <DatePicker
              picker="month"
              placeholder="Rechercher un mois"
              value={selectedKeys[0] ? dayjs(selectedKeys[0], "YYYY-MM") : null}
              format="MMM YYYY"
              disabledDate={(current) => current && current > dayjs().endOf('day')}
              onChange={(date) => {
                if (date) {
                  setSelectedKeys([date.format("YYYY-MM")]);
                } else {
                  setSelectedKeys([]);
                }
              }}
              style={{ marginBottom: 8, width: "100%" }}
            />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: "48%" }}
              >
                Réinitialiser
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: "48%" }}
              >
                Rechercher
              </Button>
            </div>
          </div>
        ),
        onFilter: (value, record) => {
          const recordMonth = moment(record.datetrait).format("YYYY-MM");
          return recordMonth === value;
        },
        sorter: (a, b) => {
          const valueA = new Date(a.datetrait).getTime();
          const valueB = new Date(b.datetrait).getTime();
          return valueA - valueB;
        },
        render: (text) => (
          <div style={{ backgroundColor: "#C7E6F8" }}>
            <b>{text ? moment(text).format("MMM-YYYY") : ""}</b>
          </div>
        ),
      },
      {
        title: "N° pièce",
        dataIndex: "numpiece",
        key: "numpiece",
        align: "center",
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8, width: 200 }}>
            {/* Recherche personnalisée */}
            <Input
              placeholder="Rechercher..."
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys([e.target.value])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8 }}
            />

            {/* Boutons */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: "48%" }}
              >
                Reset
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: "48%" }}
              >
                Ok
              </Button>
            </div>
          </div>
        ),
        filters: [
          ...new Set(
            filteredTableData.map((item) => item?.numpiece).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
          )
        ].map((value) => ({
          text: value,
          value: value,
        })),
        onFilter: (value, record) => record.numpiece === value,
        sorter: (a, b) => a.numpiece - b.numpiece,
      },
      {
        title: "N° Chèque",
        dataIndex: "numcheque",
        key: "numcheque",
        align: "center",
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8, width: 200 }}>
            {/* Recherche personnalisée */}
            <Input
              placeholder="Rechercher..."
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys([e.target.value])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8 }}
            />

            {/* Boutons */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: "48%" }}
              >
                Reset
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: "48%" }}
              >
                Ok
              </Button>
            </div>
          </div>
        ),
        filters: [
          ...new Set(
            filteredTableData.map((item) => item?.numcheque).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
          )
        ].map((value) => ({
          text: value,
          value: value,
        })),
        onFilter: (value, record) => record.numcheque === value,
        sorter: (a, b) => a.numcheque - b.numcheque,
      },
      {
        title: "N° F. IPM",
        dataIndex: "numfactipm",
        key: "numfactipm",
        align: "center",
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8, width: 200 }}>
            {/* Recherche personnalisée */}
            <Input
              placeholder="Rechercher..."
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys([e.target.value])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8 }}
            />

            {/* Boutons */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: "48%" }}
              >
                Reset
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: "48%" }}
              >
                Ok
              </Button>
            </div>
          </div>
        ),
        filters: [
          ...new Set(
            filteredTableData.map((item) => item?.numfactipm).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
          )
        ].map((value) => ({
          text: value,
          value: value,
        })),
        onFilter: (value, record) => record.numfactipm === value,
        sorter: (a, b) => a.numfactipm - b.numfactipm,
      },
      {
        title: "Cpte. Gen.",
        dataIndex: "comptegen",
        key: "comptegen",
        align: "center",
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8, width: 200 }}>
            {/* Recherche par intervalle */}
            <Input
              placeholder="Ex: 600000-602004"
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys([e.target.value])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8 }}
            />

            {/* Boutons */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: "48%" }}
              >
                Reset
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: "48%" }}
              >
                Ok
              </Button>
            </div>
          </div>
        ),
        onFilter: (value, record) => {
          if (value.includes("-")) {
            const [min, max] = value.split("-").map(Number);
            const recordValue = Number(record.comptegen);
            return recordValue >= min && recordValue <= max;
          }
          // Recherche exacte si pas d'intervalle
          return record.comptegen === value;
        },
        sorter: (a, b) => a.comptegen.localeCompare(b.comptegen),
      },

      {
        title: "Cpte. Tiers",
        dataIndex: "comptetiers",
        key: "comptetiers",
        align: "center",
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8, width: 200 }}>
            {/* Recherche personnalisée */}
            <Input
              placeholder="Rechercher..."
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys([e.target.value])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8 }}
            />

            {/* Boutons */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: "48%" }}
              >
                Reset
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: "48%" }}
              >
                Ok
              </Button>
            </div>
          </div>
        ),
        filters: [
          ...new Set(
            filteredTableData.map((item) => item?.comptetiers).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
          )
        ].map((value) => ({
          text: value,
          value: value,
        })),
        onFilter: (value, record) => record.comptetiers === value,
        sorter: (a, b) => a.comptetiers - b.comptetiers,

      },
      {
        title: "Matricule",
        dataIndex: "matri",
        key: "matri",
        align: "center",
        filters: [
          ...new Set(
            filteredTableData.map((item) => item?.matri).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
          )
        ].map((value) => ({
          text: value,
          value: value,
        })),
        onFilter: (value, record) => record.matri === value,
        sorter: (a, b) => a.matri - b.matri,
      },
      {
        title: "Libellé",
        dataIndex: "libelle",
        key: "libelle",
        filters: [
          ...new Set(
            filteredTableData.map((item) => item?.libelle).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
          )
        ].map((value) => ({
          text: value,
          value: value,
        })),
        onFilter: (value, record) => record.libelle === value,
        sorter: (a, b) => a.libelle - b.libelle,
      },
      {
        title: "Débit",
        dataIndex: "debit",
        key: "debit",
        align: "right",
        fixed: "right",
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8, width: 200 }}>
            {/* Recherche personnalisée */}
            <Input
              placeholder="Rechercher montant"
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys([e.target.value])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8 }}
            />
            {/* Plages de filtres prédéfinies */}
            <div style={{ marginBottom: 8 }}>
              <Radio.Group
                onChange={(e) => {
                  setSelectedKeys([e.target.value]);
                  confirm();
                }}
                value={selectedKeys[0]}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Radio value="100-100000">100 - 100,000</Radio>
                <Radio value="100000-1000000">100,000 - 1,000,000</Radio>
                <Radio value="1000000-">Plus de 1,000,000</Radio>
              </Radio.Group>
            </div>

            {/* Boutons */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: "48%" }}
              >
                Reset
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: "48%" }}
              >
                Ok
              </Button>
            </div>
          </div>
        ),
        onFilter: (value, record) => {
          if (value.includes("-")) {
            const [min, max] = value.split("-").map(Number);
            if (!max) return record.debit >= min; // Plus de 1,000,000
            return record.debit >= min && record.debit <= max; // Plage spécifique
          }
          const parsedValue = parseFloat(value);
          return record.debit === parsedValue; // Recherche directe
        },
        sorter: (a, b) => a.debit - b.debit,
        render: (text) => (
          <div style={{ paddingRight: 5 }}>
            <strong>
              {text && parseFloat(text) !== 0
                ? formatNumber(parseFloat(text))
                : ""}
            </strong>
          </div>
        ),
      },
      {
        title: "Crédit",
        dataIndex: "credit",
        key: "credit",
        fixed: "right",
        align: "right",
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8, width: 200 }}>
            {/* Recherche personnalisée */}
            <Input
              placeholder="Rechercher montant"
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys([e.target.value])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8 }}
            />
            {/* Plages de filtres prédéfinies */}
            <div style={{ marginBottom: 8 }}>
              <Radio.Group
                onChange={(e) => {
                  setSelectedKeys([e.target.value]);
                  confirm();
                }}
                value={selectedKeys[0]}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Radio value="100-100000">100 - 100,000</Radio>
                <Radio value="100000-1000000">100,000 - 1,000,000</Radio>
                <Radio value="1000000-">Plus de 1,000,000</Radio>
              </Radio.Group>
            </div>

            {/* Boutons */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: "48%" }}
              >
                Reset
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: "48%" }}
              >
                Ok
              </Button>
            </div>
          </div>
        ),
        onFilter: (value, record) => {
          if (value.includes("-")) {
            const [min, max] = value.split("-").map(Number);
            if (!max) return record.credit >= min; // Plus de 1,000,000
            return record.credit >= min && record.credit <= max; // Plage spécifique
          }
          const parsedValue = parseFloat(value);
          return record.credit === parsedValue; // Recherche directe
        },
        sorter: (a, b) => a.credit - b.credit,
        render: (text) => (
          <div style={{ paddingRight: 5 }}>
            <strong>
              {text && parseFloat(text) !== 0
                ? formatNumber(parseFloat(text))
                : ""}
            </strong>
          </div>
        ),
      },
    ],
    []
  );

  const monthOptions = useMemo(
    () => [
      { value: "14", label: "Date à date" },
      { value: "13", label: "Tous les mois" },
      { value: "01", label: "Janvier" },
      { value: "02", label: "Février" },
      { value: "03", label: "Mars" },
      { value: "04", label: "Avril" },
      { value: "05", label: "Mai" },
      { value: "06", label: "Juin" },
      { value: "07", label: "Juillet" },
      { value: "08", label: "Août" },
      { value: "09", label: "Septembre" },
      { value: "10", label: "Octobre" },
      { value: "11", label: "Novembre" },
      { value: "12", label: "Décembre" },
    ],
    []
  );

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  useEffect(() => {
    const filteredData = tableData1.filter((item) => {
      return Object.keys(item).some((key) =>
        item[key].toString().toLowerCase().includes(searchText1.toLowerCase())
      );
    });
    setFilteredTableData1(filteredData);
  }, [searchText1, tableData1]);

  useEffect(() => {
    const filtered = tableData.filter((item) => {
      return (
        item.libelle?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.numpiece?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.comptegen?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.matri?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.codej?.toLowerCase().includes(searchText.toLowerCase())
      );
    });
    setFilteredTableData(filtered);
  }, [searchText, tableData]);

  const getJournalLabel = (code) => {
    if (code === "All") {
      return "Tous les journaux";
    }
    const journal = journalData.find((j) => j.codej === code);
    return journal ? journal.libelle : "Journal inconnu";
  };

  const formatDateToMonthYear = (dateString) => {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "long" };
    return date.toLocaleDateString("fr-FR", options).toUpperCase();
  };

  const totalDebit = useMemo(
    () =>
      filteredTableData.reduce(
        (sum, record) => sum + parseFloat(record.debit || 0),
        0
      ),
    [filteredTableData]
  );

  const totalCredit = useMemo(
    () =>
      filteredTableData.reduce(
        (sum, record) => sum + parseFloat(record.credit || 0),
        0
      ),
    [filteredTableData]
  );

  const solde = useMemo(
    () => totalDebit - totalCredit,
    [totalDebit, totalCredit]
  );

  const totalDebit1 = useMemo(
    () =>
      tableData1.reduce(
        (sum, record) => sum + parseFloat(record.debit || 0),
        0
      ),
    [tableData1]
  );

  const totalCredit1 = useMemo(
    () =>
      tableData1.reduce(
        (sum, record) => sum + parseFloat(record.credit || 0),
        0
      ),
    [tableData1]
  );

  const solde1 = useMemo(
    () => totalDebit1 - totalCredit1,
    [totalDebit1, totalCredit1]
  );

  const refreshData = () => {
    form.resetFields();
    setAdvancedSearch({
      numpiece: "",
      datetrait: [],
      codej: "",
      numcheque: "",
      numfactipm: "",
      numfactfrs: "",
      codebenef: "",
      comptegen: "",
      comptetiers: "",
      datedeb: "",
      datefin: "",
    });
    setFilteredTableData(tableData);
    fetchData();
  };

  const formatNumber = useCallback((number) => {
    return new Intl.NumberFormat("fr-FR").format(number);
  }, []);

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
  };

  return (
    <div>
      <Row gutter={16}>
        <Col span={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "10px 20px",
              background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
              borderRadius: 10,
              boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
              marginBottom: 16,
            }}
          >
            <ReadOutlined style={{ fontSize: 22, color: "#fff" }} />
            <span
              style={{
                fontSize: 18,
                fontWeight: 600,
                color: "#fff",
                letterSpacing: 0.5,
                margin: 0,
              }}
            >
              Journal Central
            </span>
          </div>
          <p style={{ margin: "0 0 2px" }}>
            <strong>{` Exercice ${selectedYear} -  ${getJournalLabel(
              selectJournal
            )}`}</strong>
            <br></br>
            <strong
              style={{ color: "#04c953" }}
            >{` Mois Comptable:  ${formatDateToMonthYear(paramData.datedeb)} (${paramData.ouvert ? "ouvert" : "fermé"
              })`}</strong>
          </p>
          <Input
            placeholder="Recherche..."
            bordered={false}
            style={{ borderBottom: "2px solid #030303", width: "40%", top: 45 }}
            value={searchText}
            onChange={handleSearchChange}
            prefix={
              <ExpandOutlined
                style={{ color: "rgba(0,0,0,.45)", cursor: "pointer" }}
                onClick={() => setIsAdvancedSearchVisible(true)}
              />
            }
          />
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "end" }}>
          <Space>
            <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <label>Exercice</label>
              <Select
                bordered={false}
                style={{ borderBottom: "2px solid #030303", width: 100 }}
                onChange={handleYearChange}
                value={selectedYear}
              >
                {years.map((year) => (
                  <Option key={year} value={year}>
                    {year}
                  </Option>
                ))}
              </Select>
            </Space>
            <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <label>Mois</label>
              <Select
                bordered={false}
                style={{ borderBottom: "2px solid #030303", width: 140 }}
                onChange={handleMonthChange}
                value={selectedMonth}
              >
                {monthOptions.map((month) => (
                  <Option key={month.value} value={month.value}>
                    {month.label}
                  </Option>
                ))}
              </Select>
            </Space>
            {selectedMonth === "14" && (
              <Space
                direction="vertical"
                style={{ marginRight: 12, textAlign: "left" }}
              >
                <label>Periode</label>
                <RangePicker
                  value={
                    dateDeb && dateFin ? [dayjs(dateDeb), dayjs(dateFin)] : []
                  }
                  style={{ border: "2px solid #030303", width: 250 }}
                  onChange={handleDateChange}
                  format="YYYY-MM-DD"
                />
              </Space>
            )}

            <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <label>Journal</label>
              <Select
                bordered={false}
                style={{ borderBottom: "2px solid #030303", width: 300 }}
                defaultValue={selectJournal}
                onChange={onchangePrestation}
                showSearch
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value="All">Tous les journaux</Select.Option>
                {journalData.map((journal) => (
                  <Option key={journal.codej} value={journal.codej}>
                    {` ${journal.codej} - ${journal.libelle}`}
                  </Option>
                ))}
              </Select>
            </Space>
          </Space>
        </Col>
      </Row>
      <Row gutter={16} justify="end" style={{ marginBottom: 16, padding: 12 }}>
        <Col>
          <Button
            className="buttonExport"
            onClick={() =>
              exportToExcel(
                prepareDataForExport(filteredTableData),
                "JournalExport.xlsx"
              )
            }
          >
            Export Excel
          </Button>
        </Col>
        <Col>
          <Dropdown overlay={gestionMenu} trigger={["click"]}>
            <Button className="buttonCompta">Gestion</Button>
          </Dropdown>
        </Col>
        <Col>
          <Button className="buttonRefresh" onClick={refreshData}>
            Actualiser
          </Button>
        </Col>
      </Row>
      <Table
        loading={isLoading}
        scroll={{ x: true }}
        className="custom-header2-table my-custom-table"
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        bordered
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
        showSorterTooltip={false}
        dataSource={filteredTableData}
        columns={columns}
        title={() => (
          <div>
            <Row gutter={16} justify="space-between" align="middle">
              <Col>
                <Space>
                  <span>
                    <strong>Total Débit : {formatNumber(totalDebit)}</strong>
                  </span>
                  <span>
                    <strong>Total Crédit : {formatNumber(totalCredit)}</strong>
                  </span>
                  <span>
                    <strong>Solde : {formatNumber(solde)}</strong>
                  </span>
                </Space>
              </Col>
              <Col>
                <span
                  style={{
                    background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                    padding: "4px 12px",
                    borderRadius: 12,
                    fontSize: 13,
                    fontWeight: 500,
                    color: "#fff",
                    boxShadow: "0 2px 6px rgba(24, 144, 255, 0.3)",
                  }}
                >
                  {filteredTableData.length} enregistrement{filteredTableData.length > 1 ? "s" : ""}
                </span>
              </Col>
            </Row>
            <Modal
              title="Recherche Avancée"
              open={isAdvancedSearchVisible}
              onOk={executeAdvancedSearch}
              onCancel={resetAdvancedSearch}
              maskClosable={false}
              width={900}
              footer={[
                <Button key="back" onClick={resetAdvancedSearch}>
                  Réinitialiser
                </Button>,
                <Button
                  key="submit"
                  type="primary"
                  onClick={executeAdvancedSearch}
                >
                  Rechercher
                </Button>,
              ]}
            >
              <Form
                form={form}
                layout="vertical"
                onValuesChange={(changedValues, allValues) => {
                  setAdvancedSearch((prev) => ({ ...prev, ...changedValues }));
                }}
              >
                <Row gutter={16}>
                  <Col span={6}>
                    <Form.Item name="numpiece" label="N° Pièce">
                      <Input
                        bordered={false}
                        style={{ borderBottom: "2px solid #030303" }}
                        onChange={(e) =>
                          handleAdvancedSearchChange("numpiece", e.target.value)
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Date Traitement">
                      <RangePicker
                        format="DD/MM/YYYY"
                        value={[dayjs(advancedDateDeb), dayjs(advancedDateFin)]}
                        onChange={(dates) => {
                          if (dates && dates.length === 2) {
                            setAdvancedDateDeb(
                              dates[0].toISOString().split("T")[0]
                            );
                            setAdvancedDateFin(
                              dates[1].toISOString().split("T")[0]
                            );
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item name="codej" label="journal">
                      <Select
                        showSearch
                        bordered={false}
                        style={{
                          width: "100%",
                          borderBottom: "2px solid #030303",
                        }}
                      >
                        <Select.Option value="All">
                          Tous les journaux
                        </Select.Option>
                        {journalData.map((journal) => (
                          <Option key={journal.codej} value={journal.codej}>
                            {journal.codej} - {journal.libelle}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item name="numcheque" label="N°Chéque">
                      <Input
                        bordered={false}
                        style={{ borderBottom: "2px solid #030303" }}
                        onChange={(e) =>
                          handleAdvancedSearchChange(
                            "numcheque",
                            e.target.value
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="numfactipm" label="N° Facture Ipm">
                      <Input
                        bordered={false}
                        style={{ borderBottom: "2px solid #030303" }}
                        onChange={(e) =>
                          handleAdvancedSearchChange(
                            "numfactipm",
                            e.target.value
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="numfactfrs" label="Num Fact Frs">
                      <Input
                        bordered={false}
                        style={{ borderBottom: "2px solid #030303" }}
                        onChange={(e) =>
                          handleAdvancedSearchChange(
                            "numfactfrs",
                            e.target.value
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="souscompte" label="Sous Compte.">
                      <Input
                        bordered={false}
                        placeholder="Ex: 600-602"
                        style={{ borderBottom: "2px solid #030303" }}
                        onChange={(e) => {
                          const value = e.target.value;
                          handleAdvancedSearchChange("souscompte", value);
                        }}
                      />
                    </Form.Item>

                  </Col>
                  <Col span={8}>
                    <Form.Item name="comptegen" label="Compte Gen.">
                      <Input
                        bordered={false}
                        style={{ borderBottom: "2px solid #030303" }}
                        onChange={(e) => {
                          const value = e.target.value;
                          handleAdvancedSearchChange("comptegen", value);
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="comptetiers" label="Compte Tiers.">
                      <Input
                        bordered={false}
                        style={{ borderBottom: "2px solid #030303" }}
                        onChange={(e) =>
                          handleAdvancedSearchChange(
                            "comptetiers",
                            e.target.value
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Modal>
            <Modal
              title="Aperçu écritures au journal"
              open={isModalOpen}
              onCancel={() => setIsModalOpen(false)}
              maskClosable={false}
              footer={[
                <Checkbox
                  key="definitiveReport"
                  checked={isDefinitiveReport}
                  onChange={(e) => setIsDefinitiveReport(e.target.checked)}
                >
                  Report définitif ?
                </Checkbox>,
                <Button
                  className="buttonExport"
                  onClick={() =>
                    exportToExcel(
                      prepareDataForExport(filteredTableData1),
                      "JournalExport.xlsx"
                    )
                  }
                >
                  Export
                </Button>,
                <Button
                  key="back"
                  className="buttonClose"
                  onClick={() => setIsModalOpen(false)}
                >
                  Fermer
                </Button>,
                /*  <Button className="Buttonvalid">Valider</Button>, */
                <Button
                  className="Buttonvalid"
                  onClick={handleValidate}
                  loading={isValidating} // Afficher un loader sur le bouton pendant l'exécution
                >
                  Valider
                </Button>
              ]}
              width={1500}
              style={{ top: 20 }}
            >
              <Input
                placeholder="Recherche..."
                bordered={false}
                style={{
                  borderBottom: "2px solid #030303",
                  width: "20%",
                  marginBottom: 30,
                }}
                value={searchText1}
                onChange={(e) => setSearchText1(e.target.value)}
              />
              <Table
                scroll={{ x: true }}
                className="custom-header1-table"
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  width: "100%",
                }}
                bordered
                pagination={{
                  pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
                  showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
                  pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
                  onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
                }}
                loading={isLoadingModal}
                // loading={loading}
                dataSource={filteredTableData1}
                columns={columns}
                footer={() => (
                  <div style={{ textAlign: "right" }}>
                    <span>
                      <strong>Total Débit : {formatNumber(totalDebit1)}</strong>
                    </span>
                    <span>
                      <strong>
                        Total Crédit : {formatNumber(totalCredit1)}
                      </strong>
                    </span>
                    <span>
                      <strong> Solde : {formatNumber(solde1)}</strong>
                    </span>
                  </div>
                )}
              />
            </Modal>
          </div>
        )}
      />
    </div>
  );
};

export default JournalCentral;
